import type { SourceFileEntry } from '@modelviewer/core';

/** Something the app can read EF Core files from: a local folder, an uploaded copy, or (later) a GitHub repo. */
export interface WorkspaceSource {
  readonly kind: 'folder' | 'upload' | 'sample' | 'github';
  /** Stable id used to key saved layouts and workspace data. */
  readonly id: string;
  readonly label: string;
  /** Whether the source can report changes (live reload). */
  readonly live: boolean;
  /** Lists the files the app cares about (C# files, project files, `.modelviewer/`). */
  list(onProgress?: (count: number) => void): Promise<SourceFileEntry[]>;
  read(path: string): Promise<string>;
  /** Watches folders and files; returns a function that stops watching. */
  watch?(targets: WatchTargets, onChange: (change: SourceChange) => void): () => void;
}

export interface WatchTargets {
  /** Folders whose file list matters (new or removed migrations). */
  folders: string[];
  /** Files whose content matters. */
  files: string[];
}

export interface SourceChange {
  added: string[];
  removed: string[];
  changed: string[];
}

/** Files worth listing: C# sources, project files, and the agent workspace folder. */
export function isRelevantFile(path: string): boolean {
  return path.endsWith('.cs') || path.endsWith('.csproj') || path.startsWith('.modelviewer/') || path.includes('/.modelviewer/');
}
